/**
 * haptics.js
 *
 * Thin wrapper over @capacitor/haptics so call sites don't each guard for
 * native. On web (browser) every export is a no-op, matching the pattern in
 * pushNotifications.js.
 *
 * Sparing, meaningful moments only (iOS HIG): never on tab switches or
 * scrolling. See docs/in-season-ui-rework.md for the exact trigger list.
 */
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export async function hapticSuccess() {
  if (!Capacitor.isNativePlatform()) return;
  await Haptics.notification({ type: NotificationType.Success });
}

export async function hapticSelection() {
  if (!Capacitor.isNativePlatform()) return;
  await Haptics.selectionChanged();
}

export async function hapticImpact(style = 'light') {
  if (!Capacitor.isNativePlatform()) return;
  const impactStyle = style === 'medium' ? ImpactStyle.Medium : ImpactStyle.Light;
  await Haptics.impact({ style: impactStyle });
}
